export default function InfoBox({ children, spacing, previsto }) {
    return (
        <>
            <section className="bg-white drop-shadow-xl rounded-md w-full h-auto my-8 px-8 pt-3 pb-10">
                <h3 className="font-semibold p-1 text-center mt-12 text-green-600">Módulo liberado em {previsto} </h3>
            </section>
            <hr />
        </>
    )
}